import { Banknote, ClipboardCheck, ClipboardList, FileSearch, TrendingDown, Workflow } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface CreditoPipe {
  id: string;
  label: string;
  description: string;
  icon: LucideIcon;
  brand?: 'bb' | 'sicoob' | 'sicredi' | 'bradesco' | 'credisis' | 'basa';
  disabled?: boolean;
  featured?: boolean;
  kind?: 'parent' | 'child' | 'support';
}

export const CREDITO_PIPES: CreditoPipe[] = [
  {
    id: 'triagem_credito',
    label: 'Triagem',
    description: 'Entrada, análise, definição e encaminhamento.',
    icon: ClipboardList,
    featured: true,
    kind: 'parent',
  },
  {
    id: 'fno',
    label: 'Banco da Amazônia',
    description: 'Recebe CARD Filho após triagem concluída.',
    icon: Banknote,
    brand: 'basa',
    kind: 'child',
  },
  {
    id: 'bb',
    label: 'Banco do Brasil',
    description: 'Recebe CARD Filho após triagem concluída.',
    icon: Banknote,
    brand: 'bb',
    kind: 'child',
  },
  {
    id: 'sicoob_credisul',
    label: 'Sicoob Credisul',
    description: 'Recebe CARD Filho após triagem concluída.',
    icon: Workflow,
    brand: 'sicoob',
    kind: 'child',
  },
  {
    id: 'sicoob_fronteiras',
    label: 'Sicoob Fronteiras',
    description: 'Recebe CARD Filho após triagem concluída.',
    icon: Workflow,
    brand: 'sicoob',
    kind: 'child',
  },
  {
    id: 'rabobank',
    label: 'Rabobank',
    description: 'Recebe CARD Filho após triagem concluída.',
    icon: Banknote,
    kind: 'child',
  },
  {
    id: 'sicredi',
    label: 'Sicredi',
    description: 'Recebe CARD Filho após triagem concluída.',
    icon: Workflow,
    brand: 'sicredi',
    kind: 'child',
  },
  {
    id: 'bradesco',
    label: 'Bradesco',
    description: 'Recebe CARD Filho após triagem concluída.',
    icon: Banknote,
    brand: 'bradesco',
    kind: 'child',
  },
  {
    id: 'credisis',
    label: 'Credisis',
    description: 'Recebe CARD Filho após triagem concluída.',
    icon: Workflow,
    brand: 'credisis',
    kind: 'child',
  },
  {
    id: 'renegociacao_prorrogacao',
    label: 'Renegociação / Prorrogação',
    description: 'Acompanha documentos, laudo, envio e decisão da instituição.',
    icon: TrendingDown,
    kind: 'support',
  },
  {
    id: 'cedulas_registro',
    label: 'Emissão da Cédula e Cartório',
    description: 'Recebe operações aprovadas e acompanha emissão, conferência, protocolo e registro da cédula.',
    icon: FileSearch,
    kind: 'support',
  },
  {
    id: 'comprovacoes',
    label: 'Comprovações',
    description: 'Controla o laudo e cada parcela até a liberação do recurso.',
    icon: ClipboardCheck,
    kind: 'support',
  },
];

export const FINALIDADE_LABEL: Record<string, string> = {
  custeio: 'Custeio',
  investimento: 'Investimento',
  comercializacao: 'Comercialização',
  industrializacao: 'Industrialização',
};
